import { Controller } from "@hotwired/stimulus"

// Elements / Sections switch in the left pane.
export default class extends Controller {
  static targets = ["tab", "pane"]

  show(event) {
    const wanted = event.currentTarget.dataset.pane

    this.paneTargets.forEach((pane) => { pane.hidden = pane.dataset.pane !== wanted })
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.pane === wanted
      tab.classList.toggle("bg-slate-100", active)
      tab.classList.toggle("text-slate-900", active)
      tab.classList.toggle("dark:bg-slate-800", active)
      tab.classList.toggle("dark:text-slate-100", active)
      tab.classList.toggle("text-slate-500", !active)
    })
  }
}
